// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._f-0 {\n  display: flex;\n}\n\n._f-1 {\n  flex-direction: row;\n}\n\n._f-2 {\n  flex-direction: column;\n}\n\n._f-3 {\n  flex-direction: row-reverse;\n}\n\n._f-4 {\n  flex-direction: column-reverse;\n}\n\n._f-5 {\n  align-items: center;\n}\n._f-6 {\n  align-items: flex-start;\n}\n._f-7 {\n  align-items: flex-end;\n}\n._f-8 {\n  align-items: stretch;\n}\n._f-9 {\n  align-items: baseline;\n}\n\n._f-a {\n  align-self: center;\n}\n._f-b {\n  align-self: flex-start;\n}\n._f-c {\n  align-self: flex-end;\n}\n._f-d {\n  align-self: stretch;\n}\n._f-e {\n  align-self: baseline;\n}\n\n._f-f {\n  justify-content: center;\n}\n._f-g {\n  justify-content: flex-start;\n}\n._f-h {\n  justify-content: flex-end;\n}\n._f-i {\n  justify-content: space-between;\n}\n._f-j {\n  justify-content: space-around;\n}\n._f-k {\n  justify-content: space-evenly;\n}\n\n._f-l {\n  flex-wrap: wrap;\n}\n\n._f-m {\n  flex-wrap: nowrap;\n}\n\n._f-n {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_f-0";
export var row = "_f-1";
export var column = "_f-2";
export var rowReverse = "_f-3";
export var columnReverse = "_f-4";
export var alignCenter = "_f-5";
export var alignFlexStart = "_f-6";
export var alignFlexEnd = "_f-7";
export var alignStretch = "_f-8";
export var alignBaseline = "_f-9";
export var alignSelfCenter = "_f-a";
export var alignSelfFlexStart = "_f-b";
export var alignSelfFlexEnd = "_f-c";
export var alignSelfStretch = "_f-d";
export var alignSelfBaseline = "_f-e";
export var justifyCenter = "_f-f";
export var justifyFlexStart = "_f-g";
export var justifyFlexEnd = "_f-h";
export var justifySpaceBetween = "_f-i";
export var justifySpaceAround = "_f-j";
export var justifySpaceEvenly = "_f-k";
export var wrapWrap = "_f-l";
export var wrapNowrap = "_f-m";
export var wrapWrapReverse = "_f-n";
export default ___CSS_LOADER_EXPORT___;
